import React from "react";
import { SelectInput, required } from "react-admin";
import { useForm } from "react-final-form";
import { ICountryAppData } from "../../../common/redux/reducers/appDataReducer";

interface Props {
  getSource: (source: string) => string;
  countries: ICountryAppData[];
  scopedFormData?: any;
  selectedCountriesRef: React.MutableRefObject<{
    [key: string]: {
      id: number;
      remainingChoices: ICountryAppData[];
    };
  }>;
  disabled?: boolean;
}

export const DrivingCountryCycleRuleSelector = ({
  getSource,
  scopedFormData,
  countries,
  selectedCountriesRef,
  disabled,
  ...rest
}: Props) => {
  const form = useForm();
  return (
    <div className="two-inputs-container">
      <SelectInput
        disabled={disabled}
        source={getSource("drivingCountryId")}
        validate={required()}
        choices={
          selectedCountriesRef.current[getSource("drivingCountryId")]
            .remainingChoices
        }
        onChange={() => form.change(getSource("cycleRuleId"), null)}
        {...rest}
        label="resources.common.labels.drivingCountry"
      />
      <SelectInput
        disabled={disabled}
        source={getSource("cycleRuleId")}
        validate={required()}
        choices={
          countries.find((x) => x.id === scopedFormData?.drivingCountryId)
            ?.dutyCycles ?? []
        }
        {...rest}
        label="resources.common.labels.cycleRule"
      />
    </div>
  );
};
